import classnames from 'classnames';
import autobind from 'core-decorators/lib/autobind';

import { WixConnect } from 'widget/player-widget/utils/wix-connect';

import { pickContextTypes } from '../context-types';

import Icon from 'widget/player-widget/components/icon/icon';

import styles from './info-overlay.styl';


@WixConnect(styles)
export default class InfoOverlay extends React.Component {

  static contextTypes = pickContextTypes('toggleInfoOverlay', 'videoItem', 'fullScreen');

  static propTypes = {
    closeOnBodyClick: React.PropTypes.bool,
    noPoster: React.PropTypes.bool,
    isFullWidth: React.PropTypes.bool,
    content: React.PropTypes.element,
  };

  state = {
    isVisibleInfoOverlay: false,
  };

  componentWillMount() {
    setTimeout(() => {
      this.setState({
        isVisibleInfoOverlay: true,
      });
    }, 0);
  }

  componentDidMount() {
    const { closeOnBodyClick } = this.props;

    this.backgroundOverlay.addEventListener('click', this.handleBodyClick);

    if (closeOnBodyClick) {
      document.body.addEventListener('click', this.handleBodyClick);
    }
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (_.get(nextContext, 'videoItem.id') !== _.get(this.context, 'videoItem.id')) {
      this.close();
    }
  }

  componentWillUnmount() {
    const { closeOnBodyClick } = this.props;

    this.backgroundOverlay.removeEventListener('click', this.handleBodyClick);

    if (closeOnBodyClick) {
      document.body.removeEventListener('click', this.handleBodyClick);
    }
  }

  @autobind
  close() {
    const { toggleInfoOverlay } = this.context;

    this.setState({
      isVisibleInfoOverlay: false,
    });

    setTimeout(toggleInfoOverlay, 200);
  }

  @autobind
  handleBodyClick() {
    this.close();
  }

  get closeButton() {
    const { fullScreen } = this.context;

    const iconName = fullScreen ? 'thin-x' : 'exit';
    const styleName = classnames('close', {
      'close-fullscreen': fullScreen,
    });

    return (
      <Icon styleName={styleName}
            name={iconName}
            onClick={this.close} />
    );
  }

  render() {
    const { content, noPoster, isFullWidth } = this.props;
    const { isVisibleInfoOverlay } = this.state;
    const { videoItem: { posterUrl }, fullScreen } = this.context;

    const styleNames = classnames('info-overlay', {
      show: isVisibleInfoOverlay,
      'full-width': isFullWidth,
    });

    const contentStyleNames = classnames('content', {
      half: noPoster && !posterUrl,
      'full-screen': noPoster && fullScreen,
    });

    return (
      <div styleName={styleNames}>
        {this.closeButton}
        <div styleName={contentStyleNames}>
          {content}
        </div>
        <div styleName="background-overlay"
             ref={node => (this.backgroundOverlay = node)} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/player-widget/components/player/info-overlay/info-overlay.js